import P5 from "p5";
import ICameraWrapper from "./ICameraWrapper";

export default class CameraWrapper implements ICameraWrapper {
    public zoom_factor: number = 20;
    public PI_DIV_BY_180!: number;
    public rightVector: P5.Vector = new P5.Vector(1,0,0);
    public rightVectorUndo: P5.Vector = new P5.Vector(1,0,0);
    public upVector: P5.Vector = new P5.Vector(0,1,0);
    public upVectorUndo: P5.Vector = new P5.Vector(0,1,0);
    public viewDir: P5.Vector = new P5.Vector(0,0,-1);
    public viewDirUndo: P5.Vector = new P5.Vector(0,0,-1);

    public position: P5.Vector;
    public viewPoint: P5.Vector = new P5.Vector(0,0,0);
    public strafeFactor: number;
    public __P5Instance!: P5;
    public cam!: P5.Camera;
    public hudCam: P5.Camera;
  
    constructor(x: number, y: number, z: number, strafeFactor: number, p5Instance: P5) {
        this.position = new P5.Vector(x, y, z);
        this.strafeFactor = strafeFactor;

        this.__P5Instance = p5Instance;
        this.PI_DIV_BY_180 = this.__P5Instance.PI/180;
        this.cam = this.__P5Instance.createCamera();
        this.hudCam = this.__P5Instance.createCamera();
    }

    public setPositionTo(position: P5.Vector): void {
        this.position = position;
        this.cam.setPosition(position.x, position.y, position.z);
        this.cam.centerX = 0;
        this.cam.centerY = 0;
        this.cam.centerZ = 0;
        this.cam.upX = this.upVector.x;
        this.cam.upY = this.upVector.y;
        this.cam.upZ = this.upVector.z;
        //this.cam.camera();
        //this.cam.ortho();
        //this.__P5Instance.setCamera(this.cam);
    }
  
    public render(): void {
        this.__P5Instance.camera(
            this.position.x,
            this.position.y,
            this.position.z,
            // center is intentionally set to the origin, model will be translated to the center.
            0,0,0,
            this.upVector.x,
            this.upVector.y,
            this.upVector.z);
    }
  
    public rotateAroundXAxis(angle: number): void {
        // rotate viewDir around the right vector:
        const viewDirComponent: P5.Vector = this.getViewDirComponent(angle);
        const upVectorComponent: P5.Vector = this.upVector.copy();
        upVectorComponent.mult(Math.sin(angle*this.PI_DIV_BY_180));

        viewDirComponent.add(upVectorComponent);
        viewDirComponent.normalize();

        this.viewDir.set(viewDirComponent);

        // now compute the new up Vector
        this.upVector = this.viewDir.cross(this.rightVector);
        this.upVector.mult(-1);
    }

    public rotateAroundXAxisUndo(angle: number): void {

    }
  
    public rotateAroundYAxis(angle: number): void {
        // rotate viewDir around the up vector:
        const viewDirComponent: P5.Vector = this.getViewDirComponent(angle);
        const rightVectorComponent: P5.Vector = this.rightVector.copy();
        rightVectorComponent.mult(Math.sin(angle*this.PI_DIV_BY_180));

        viewDirComponent.sub(rightVectorComponent);
        viewDirComponent.normalize();
  
        this.viewDir.set(viewDirComponent);
   
        // now compute the new rightVector
        this.rightVector = this.viewDir.cross(this.upVector);
    }
    
    public rotateAroundOrigin(x: number, y: number): void {
        if (x == 0 && y == 0)
            return;

        const previousComponents:P5.Vector = new P5.Vector(
            this.position.dot(this.rightVector),
            this.position.dot(this.upVector),
            this.position.dot(this.viewDir));

        this.position.set(0,0,0);

        this.rotateAroundXAxis(x);
        this.rotateAroundYAxis(y);

        // go back by the recorded vector
        const tempRightVector: P5.Vector = this.rightVector.copy();
        tempRightVector.mult(previousComponents.x);
        
        const tempUpVector: P5.Vector = this.upVector.copy();
        tempUpVector.mult(previousComponents.y);
        
        const tempViewDir: P5.Vector = this.viewDir.copy();
        tempViewDir.mult(previousComponents.z);

        this.position.add(tempRightVector);
        this.position.add(tempUpVector);
        this.position.add(tempViewDir);

        this.setPositionTo(this.position);/*
        this.cam.lookAt(this.viewDir.x, this.viewDir.y, this.viewDir.z);
        this.cam.upX = this.upVector.x;
        this.cam.upY = this.upVector.y;
        this.cam.upZ = this.upVector.z;
        this.cam.eyeX = this.viewDir.x;
        this.cam.eyeY = this.viewDir.y;
        this.cam.eyeZ = this.viewDir.z;*/
    }
    
    public viewAt(point: P5.Vector): void {
        this.viewPoint = point;
        this.position.z = -400;
    }
    
    public strafeUp(): void {
        this.position.y += this.strafeFactor;
        this.viewPoint.y += this.strafeFactor;
    }
  
    public strafeDown(): void {
        this.position.y -= this.strafeFactor;
        this.viewPoint.y -= this.strafeFactor;
    }
  
    public strafeLeft(): void {
        this.position.x -= this.strafeFactor;
        this.viewPoint.x -= this.strafeFactor;
    }
  
    public strafeRight(): void {
      this.position.x += this.strafeFactor;
      this.viewPoint.x += this.strafeFactor;
    }
    
    public zoomOut(): void {
        this.zoom(-this.zoom_factor); 
    }
    
    public zoomIn(): void {
        this.zoom(this.zoom_factor);
    }
  
    public zoom(zoomFactor: number): void {
        const v: P5.Vector = this.viewDir.copy();
        v.mult(zoomFactor);
        this.position.add(v.x, v.y, v.z);
        /*this.setPositionTo(this.position);
        this.__P5Instance.camera(
            this.position.x,
            this.position.y,
            this.position.z,
            // center is intentionally set to the origin, model will be translated to the center.
            0,0,0,
            this.upVector.x,
            this.upVector.y,
            this.upVector.z);*/
    }
  
    public getViewDirComponent(angle: number): P5.Vector {
        const viewDirComponent: P5.Vector = this.viewDir.copy();
        viewDirComponent.mult(Math.cos(angle*this.PI_DIV_BY_180));
        return viewDirComponent;
    }

    public setHudCamera(x: number, y: number): void {
        this.hudCam.setPosition(x, y, 500);
        this.hudCam.ortho();
    }
  }
  